import { Button, Result } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SingleServiceActivationResult = ({ service, license }) => {
  const { t } = useTranslation();

  return (
    <Result
      status={service && service.state === 'on' ? 'success' : 'info'}
      title={
        service && service.state === 'on'
          ? t('The service has been activated!')
          : t('Service activation required!')
      }
      subTitle={t('_START_AT_START_END', {
        startAt: service && service.startAt,
      })}
      extra={[
        <Button disabled={!license} type="primary" key="activate">
          {t('Activate the service')}
        </Button>,
      ]}
    />
  );
};

export default SingleServiceActivationResult;
